<div class="news-list-container pt-2">
    <div *ngIf="showNews" class="news-container">
        <div class="news-items">
            <div *ngFor="let news of newsList" class="news-row">
                <a href="#" class="news-link" [ngClass]="news.className"> {{ news.title }} </a>
                <html-viewer-control class="news-content" [texthtml]="news.content"> </html-viewer-control>
                <button-control *ngIf="!news.isRead" class="news-read-button" buttonType="button" themeColor="primary" [buttonText]="'news_list.read'" (onClick)="markNewsAsRead(news)"> </button-control>
            </div>
        </div>
        <button-control *ngIf="!allNewsAsRead" class="read-all-button" buttonType="button" themeColor="info" [buttonText]="'news_list.read_all'" (onClick)="markAllNewsAsRead()"> </button-control>
    </div>

    <div *ngIf="!showNews">
        <span>{{ 'news_list.no_news' | translate }}</span>
    </div>
</div>
